import { api } from '@src/constants/api';
import { createMiddleware, Next } from '@src/utils';
import { cmsActions } from '@src/store/reducers/cmsReducer';

export const createCmsMiddleware = (http: any, successPopUp: any, errorPopUp: any) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [cmsActions.GET_ALL_CMS]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Cms`);
            const data = response.data;
            next({ type: cmsActions.SET_ALL_CMS, payload: { cmss: data } });
            return data;
        },
        [cmsActions.GET_CMS_BY_ID]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Cms/${payload.cmdId}`);
            next({ type: cmsActions.SET_CMS_BY_ID, payload: { cms: response.data } });
            return response.data;
        },
        [cmsActions.GET_QUERIES]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Cms/${payload.projectId}/Queries`);
            const data = response.data;
            next({ type: cmsActions.SET_QUERIES, payload: { queries: data } });
            return data;
        },
        [cmsActions.GET_TASKS_BY_PROJECT_ID]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Cms/${payload.projectId}/Tasks`);
            const data = response.data;
            next({ type: cmsActions.SET_ALL_TASKS, payload: { tasks: data } });
            return data;
        },
        [cmsActions.GET_CHECKIN_TASKS_BY_PROJECT_ID]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Cms/${payload.projectId}/Build/CheckedIn/Tasks`);
            const data = response.data;
            next({ type: cmsActions.SET_ALL_TASKS, payload: { tasks: data } });
            return data;
        },
        [cmsActions.GET_TASKS_BY_QUERY_ID]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Cms/${payload.projectId}/${payload.queryId}`);
            const data = response.data;
            next({ type: cmsActions.SET_ALL_TASKS, payload: { tasks: data } });
            return data;
        },
        [cmsActions.ADD_CMS]: async (action: any, next: Next) => {
            try{
                const response = await http.post(`${restServiceUrl}Cms`, action.payload.cmsData);
                const data = response.data;
    
                if (!data) {
                    errorPopUp();
                } else {
                    successPopUp();
                    next({ type: action.type, payload: data });
                }
    
                return data;
            }
          catch{
              
          }
        },
        [cmsActions.DELETE_CMS]: async ({ payload }: any, next: Next) => {
            try {
                const response = await http.delete(`${restServiceUrl}Cms/${payload.cmsId}`);
                next({ type: cmsActions.REFRESH_DELETE_CMS, payload: payload.cmsId });
                return response;
            } catch (error) {
                return error;
            }
        },
        [cmsActions.SAVE_CMS]: async (action: any, next: Next, state: any) => {
            const response = await http.put(`${restServiceUrl}Cms`, action.payload.cmsData);
            const data = response.data;
            if (!data) {
                errorPopUp();
            } else {
                successPopUp();
                next({ type: action.type, payload: data });
                state.dispatch({ type: cmsActions.GET_CMS_BY_ID, payload: { cmdId: action.payload.cmsData.id } });
            }
            return data;
        },
        [cmsActions.GET_CMS_TYPES]: async (_: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}CmsTypes`);
            const data = response.data;
            next({ type: cmsActions.SET_CMS_TYPES, payload: data });
            return data;
        },
        [cmsActions.GET_CMS_PROJECTS]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Cms/${payload.cmsId}/Projects`);
            const data = response.data;
            next({ type: cmsActions.GET_CMS_PROJECTS, payload: data });
            return data;
        },
        [cmsActions.ADD_JIRA_QUERY_TASK]: async ({ payload }: any) => {
            const response = await http.post(`${restServiceUrl}Cms/${payload.projectId}/Query/Create`, payload.data);
            return response.data;
        },
        [cmsActions.EDIT_JIRA_QUERY_TASK]: async ({ payload }: any) => {
            const response = await http.put(`${restServiceUrl}Cms/${payload.projectId}/Query/${payload.queryId}/Update`, payload.data);
            return response.data;
        },
        [cmsActions.DELETE_JIRA_QUERY_TASK]: async (action: any, next: Next) => {
            const payload = action.payload;
            const response = await http.delete(`${restServiceUrl}Cms/${payload.projectId}/Query/${payload.queryId}/Delete`);
            const data = response.data;
            if (data) {
                next({ type: action.type, payload: payload.taskId });
            }
            return data;
        },
        [cmsActions.GET_ALL_JIRA_CMS_TASKS_QUERYS]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Cms/${payload.projectId}/Queries`);
            const data = response.data;
            next({ type: cmsActions.SET_ALL_TASKS, payload: { tasks: data } });
            return data;
        },
        [cmsActions.TEST_CMS_CONNECTION]: async ({ payload }: any, next: Next) => {
            const response = await http.post(`${restServiceUrl}CmsTestDetails`, payload);
            const data = response.data.Result;
            next({ type: cmsActions.REUSLT_TEST_CMS_CONNECTION, payload: data });
            return data;
        },
        [cmsActions.TEST_JIRA_QUERY_TASK_CONNECTION]: async ({ payload }: any, next: Next) => {
            const response = await http.post(`${restServiceUrl}Cms/${payload.projectId}/Query/Test`, payload);
            const data = response.data;
            next({ type: cmsActions.TEST_JIRA_QUERY_TASK_CONNECTION, payload: data });
            return data;
        },
        [cmsActions.GET_ALL_TASKS_WITH_CMS_ID]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Cms/${payload.projectId}/${payload.cmsId}/Tasks`);
            const data = response.data;
            next({ type: cmsActions.SET_ALL_TASKS, payload: { tasks: data } });
            return data;
        },
        [cmsActions.GET_ALL_TASKS]: async ({ payload }: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Cms/${payload.projectId}/Tasks`);
            const data = response.data;
            next({ type: cmsActions.SET_ALL_TASKS, payload: { tasks: data } });
            return data;
        },
        [cmsActions.ADD_TASK]: async ({ payload }: any, next: Next) => {
            const response = await http.post(`${restServiceUrl}DBmaestroCms/CreateNewTask`, payload.data);
            const data = response.data;
            next({ type: cmsActions.SET_TASK, payload: data });
            return data;
        },
        [cmsActions.UPDATE_TASK]: async (action: any, next: Next) => {
            const response = await http.put(`${restServiceUrl}DBmaestroCms`, action.payload.data);
            const data = response.data;
            if (data) {
                next({ type: cmsActions.SET_UPDATE_TASK, payload: action.payload.data });
            }
            return data;
        },
        [cmsActions.DELETE_TASK]: async (action: any, next: Next) => {
            const response = await http.delete(`${restServiceUrl}DBmaestroCms/${action.payload.taskId}`);
            const data = response.data;
            if (data) {
                next({ type: action.type, payload: action.payload.taskId });
            }
            return data;
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/cms.middleware.ts